// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"PrimaryButton_primaryButton__1EbA9"};